import React, {useCallback, useEffect, useState} from 'react';
import {
    IonModal,
    IonContent, IonIcon, IonButton, IonChip,
} from '@ionic/react';
import {
    businessOutline,
    calendarOutline, chevronBack,
    chevronBackOutline, chevronForward,
    downloadOutline,
    locationOutline,
} from "ionicons/icons";
// import moment from "moment-timezone";
import {FacebookLoader} from "./Loader/FacebookLoader";
import {actionToGetUserContributionByFilter} from "../apiHelpers/CommonAction";
import useStore from "../zustand/useStore";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const ITEMS_PER_PAGE = 10;
export default function UserTransactionHistoryModal({ isOpen, onDidDismiss }) {

    const [currentPage, setCurrentPage] = useState(1);

    const { userContributionDataState } = useStore();
    const { contributions, loading, totalCount ,allContributions} = userContributionDataState;

    const pageCount = Math.ceil((totalCount || 0) / ITEMS_PER_PAGE);

    const fetchPageData = useCallback((page) => {
        const newOffset = (page - 1) * ITEMS_PER_PAGE;
        setCurrentPage(page);
        actionToGetUserContributionByFilter(false, {offset: newOffset})
    }, []);

    useEffect(() => {
        fetchPageData(1);
    }, [fetchPageData]);

    const handlePrev = () => {
        if (currentPage > 1) {
            fetchPageData(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < pageCount) {
            fetchPageData(currentPage + 1);
        }
    };

    const downloadExcel = () => {
        // Sort by ID (ascending)
        const sortedData = [...allContributions].sort((a, b) => a.id - b.id);

        // Map only selected fields for Excel
        const formattedData = sortedData.map((item) => ({
            'Payment ID': item.razorpay_payment_id,
            Amount: item.amount,
            Status: item.payment_status,
            Currency: item.currency,
            'Order ID': item.razorpay_order_id,
            'Member ID': item.member_id,
            'Date': item.created_at,
        }));

        // Convert JSON → Worksheet
        const worksheet = XLSX.utils.json_to_sheet(formattedData);

        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Payments");

        // Generate Excel & trigger download
        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const blob = new Blob([excelBuffer], {
            type: "application/octet-stream",
        });

        saveAs(blob, "payments.xlsx");
    };

    return (
        <IonModal
            isOpen={isOpen}
            onDidDismiss={onDidDismiss}
            initialBreakpoint={1}
            breakpoints={[0, 1]}
            handleBehavior="cycle"
        >
            <IonContent className="ion-padding news-letter-content-page">
                <div className="user_inner_tab_container">
                    <div className="header-row">
                        {onDidDismiss ? <button onClick={onDidDismiss} className="circle-btn mt-0">
                            <IonIcon icon={chevronBackOutline} />
                        </button> : ""}
                        <h2 className="newsletter-heading">All Contributions</h2>
                        {contributions?.length > 0 ?
                            <button className="newsletter-heading_right download-button" onClick={() => downloadExcel()}>
                                <IonIcon size={1} icon={downloadOutline}  />
                                <span>Download</span>
                            </button> :""
                        }
                    </div>

                    <div className="newsletter-table-container">
                        <table className="newsletter-table">
                            <thead>
                            <tr>
                                <th>Transaction Id</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Date</th>
                            </tr>
                            </thead>
                            <tbody>
                            {loading ? (
                                <>
                                    {[...Array(2)].map((_, idx) => (
                                        <tr key={idx}>
                                            <td><FacebookLoader type={"facebookStyle"} item={1} /></td>
                                            <td><FacebookLoader type={"facebookStyle"} item={1} /></td>
                                            <td><FacebookLoader type={"facebookStyle"} item={1} /></td>
                                            <td><FacebookLoader type={"facebookStyle"} item={1} /></td>
                                            <td><FacebookLoader type={"facebookStyle"} item={1} /></td>
                                            <td><FacebookLoader type={"facebookStyle"} item={1} /></td>
                                            <td><FacebookLoader type={"facebookStyle"} item={1} /></td>
                                        </tr>
                                    ))}
                                </>
                            ) : contributions?.length > 0 ? (
                                contributions.map((item) => (
                                    <tr key={item.id}>
                                        <td>{item.razorpay_payment_id ?? ' - '}</td>
                                        <td>{item.amount}</td>
                                        <td>{item.payment_status}</td>
                                        <td>{new Date(item.created_at).toLocaleDateString()}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: 'center', padding: '1rem' }}>
                                        No contributions found.
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination Controls */}
                    <div className="pagination-controls">
                        <button
                            type="button"
                            className="pagination_button"
                            disabled={currentPage === 1}
                            onClick={handlePrev}
                        >
                            <IonIcon icon={chevronBack} />
                        </button>
                        <span className="page-info">
                            Page {currentPage} of {pageCount}
                        </span>
                        <button
                            type="button"
                            className="pagination_button"
                            disabled={currentPage === pageCount}
                            onClick={handleNext}
                        >
                            <IonIcon icon={chevronForward} />
                        </button>
                    </div>
                </div>
            </IonContent>
        </IonModal>

    );
}
